import React, { useEffect, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { CheckCircle, AlertCircle, Loader } from "lucide-react";

const PaymentSuccess = () => {
  const { quoteId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const paymentMethod = searchParams.get("method");
  const orderId = searchParams.get("token"); // PayPal token/order ID

  useEffect(() => {
    const processPayPalPayment = async () => {
      if (paymentMethod === "paypal" && orderId) {
        try {
          setLoading(true);
          setError("");

          // Envoyer la requête pour capturer le paiement PayPal
          const response = await axios.get(
            `https://api.greenecobagsusa.com/api/payments/paypal/capture?order_id=${orderId}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("clientToken")}`,
              },
            }
          );

          if (response.data.success) {
            setSuccess(true);
          } else {
            setError("Le traitement du paiement a échoué. Veuillez réessayer.");
          }
        } catch (err) {
          console.error("Erreur de capture PayPal:", err);
          setError(
            err.response?.data?.message ||
            "Une erreur s'est produite lors de la finalisation du paiement."
          );
        } finally {
          setLoading(false);
        }
      } else {
        // Si c'est une autre méthode de paiement ou si les paramètres sont manquants
        setLoading(false);
        if (paymentMethod !== "paypal") {
          setSuccess(true); // Pour Stripe, considérer comme déjà traité
        } else {
          setError("Paramètres de paiement PayPal incomplets.");
        }
      }
    };

    processPayPalPayment();
  }, [paymentMethod, orderId, quoteId]);

  const handleContinue = () => {
    navigate(`/client/dashboard/${quoteId}`);
  };

  return (
    <div className="max-w-lg mx-auto my-12 p-6 bg-white rounded-lg shadow-md">
      {loading ? (
        <div className="flex flex-col items-center justify-center py-8">
          <Loader className="h-12 w-12 text-blue-500 animate-spin mb-4" />
          <p className="text-gray-600 text-center">
            Traitement de votre paiement en cours...
          </p>
        </div>
      ) : error ? (
        <div className="flex flex-col items-center justify-center py-6">
          <AlertCircle className="h-16 w-16 text-red-500 mb-4" />
          <h2 className="text-xl font-bold text-gray-800 mb-2">
            Erreur de paiement
          </h2>
          <p className="text-gray-600 text-center mb-6">{error}</p>
          <button
            onClick={handleContinue}
            className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
          >
            Retour au tableau de bord
          </button>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center py-6">
          <CheckCircle className="h-16 w-16 text-green-500 mb-4" />
          <h2 className="text-xl font-bold text-gray-800 mb-2">
            Paiement réussi !
          </h2>
          <p className="text-gray-600 text-center mb-6">
            Merci pour votre paiement. Votre commande a été confirmée et sera
            traitée prochainement.
          </p>
          <button
            onClick={handleContinue}
            className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
          >
            Continuer
          </button>
        </div>
      )}
    </div>
  );
};

export default PaymentSuccess;